import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	extensionTitle: {
		id: 'company-hub.callout-banner-extension.manifest.extension-title',
		defaultMessage: 'Callout banner',
		description:
			'Title of callout banner extension to be displayed in toolbar/shortcut macros dropdown.',
	},
	extensionTitleNew: {
		id: 'company-hub.callout-banner-extension.manifest.extension-title.new',
		defaultMessage: 'Callout banner [New]',
		description:
			'Title of callout banner extension to be displayed in toolbar/shortcut macros dropdown.   The [New] text is a text label indicating that this feature is new.',
	},
	extensionDescription: {
		id: 'company-hub.callout-banner-extension.manifest.extension-description',
		defaultMessage: 'Create an engaging header for your page.',
		description:
			'Description of callout banner extension to be displayed in toolbar/shortcut macros dropdown',
	},
	title: {
		id: 'company-hub.callout-banner-extension.manifest.title',
		defaultMessage: 'Hi, how can we help?',
		description:
			'Initial text title parameter of callout banner extension to be displayed in the UI of the editor and view page.',
	},
});
